/**
 * @generated SignedSource<<e77f08c83db40ba8daa33ebd22f1d70a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserContactStatus = "ELIGIBLE_FOR_ACTIVATION" | "NOT_TAKEN" | "UNVERIFIED" | "VERIFIED";
export type UserEmailStatusInput = {
  email: string;
};
export type useCheckUserEmailStatusMutation$variables = {
  input: UserEmailStatusInput;
};
export type useCheckUserEmailStatusMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly result: UserContactStatus | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCheckUserEmailStatusMutation = {
  response: useCheckUserEmailStatusMutation$data;
  variables: useCheckUserEmailStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCheckUserEmailStatusMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UserEmailStatusPayload",
        "kind": "LinkedField",
        "name": "userEmailStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCheckUserEmailStatusMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UserEmailStatusPayload",
        "kind": "LinkedField",
        "name": "userEmailStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b2ac823e93c6d4050e7a329a5cd4d4c4",
    "id": null,
    "metadata": {},
    "name": "useCheckUserEmailStatusMutation",
    "operationKind": "mutation",
    "text": "mutation useCheckUserEmailStatusMutation(\n  $input: UserEmailStatusInput!\n) {\n  responsePayload: userEmailStatus(input: $input) {\n    success\n    result\n    errors {\n      __typename\n      field\n      code\n      message: code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "10f9e0787f960c7de111eae9e9743720";

export default node;
